import { DateTime } from 'luxon';
import { ModelEventoDTO } from 'shell/models/act-category-list';
import { AccordionEditDataControl } from 'shell/view-models/edit-data-control';

export const transformEditDataControl = (data: ModelEventoDTO): AccordionEditDataControl => {
  return {
    dateValidity: data.datiEventoCittadinanza?.dataAcquisizioneCittadinanza
      ? DateTime.fromISO(data.datiEventoCittadinanza?.dataAcquisizioneCittadinanza)
      : null,
  };
};
